import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
    Command,
    CommandEmpty,
    CommandGroup,
    CommandInput,
    CommandItem,
    CommandList,
} from "@/components/ui/command";
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "@/components/ui/popover";
import { useState } from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { PiUserCircleDashed } from "react-icons/pi";

export function TaskAssigneeSelect({ users, value, onChange, className, showName = false }) {
    const [open, setOpen] = useState(false);

    const selectedUser = users.find(user => user.id === value);

    return (
        <div className={className}>
            <Popover open={open} onOpenChange={setOpen}>
                <PopoverTrigger asChild>
                    <Button 
                        variant="ghost" 
                        size="sm" 
                        className={`${showName ? "h-7 px-1.5 -ml-1.5 flex items-center gap-2" : "h-5 w-5 p-0 rounded-full bg-none hover:opacity-50"}`}
                    >
                        {selectedUser ? (
                            <>
                                <Avatar className="h-5 w-5">
                                    <AvatarImage src={selectedUser.avatar} />
                                    <AvatarFallback className={`${selectedUser.avatarColor || 'bg-neutral-600'} text-neutral-200 text-[0.65rem]`}>
                                        {selectedUser.initials}
                                    </AvatarFallback>
                                </Avatar>
                                {showName && <span>{selectedUser.name}</span>}
                            </>
                        ) : (
                            <>
                                <Avatar className="h-5 w-5">
                                    <PiUserCircleDashed className="text-neutral-500 h-5 w-5" />
                                </Avatar>
                                {showName && <span>Unassigned</span>}
                            </>
                        )}
                    </Button>
                </PopoverTrigger>
                <PopoverContent className="w-[200px] p-0" side="top" align="start">
                    <Command>
                        <CommandInput placeholder="Assign to..." />
                        <CommandList>
                            <CommandEmpty>No users found.</CommandEmpty>
                            <CommandGroup>
                                <CommandItem
                                    value="unassigned"
                                    onSelect={() => {
                                        onChange(null);
                                        setOpen(false);
                                    }}
                                >
                                    <div className="flex items-center gap-2">
                                        <Avatar className="h-5 w-5">
                                            <PiUserCircleDashed className="text-neutral-500 h-5 w-5" />
                                        </Avatar>
                                        <span>Unassigned</span>
                                    </div>
                                    {!value && (
                                        <Check className="ml-auto h-4 w-4" />
                                    )}
                                </CommandItem>
                                {users.map((user) => (
                                    <CommandItem
                                        key={user.id}
                                        value={user.id}
                                        keywords={[user.name, user.email || ""]}
                                        onSelect={() => {
                                            onChange(user.id);
                                            setOpen(false);
                                        }}
                                    >
                                        <div className="flex items-center gap-2">
                                            <Avatar className="h-5 w-5">
                                                <AvatarImage src={user.avatar} />
                                                <AvatarFallback className={`${user.avatarColor || 'bg-neutral-600'} text-neutral-200 text-[0.65rem]`}>
                                                    {user.initials}
                                                </AvatarFallback>
                                            </Avatar>
                                            <span>{user.name}</span>
                                        </div>
                                        {value === user.id && (
                                            <Check className="ml-auto h-4 w-4" />
                                        )}
                                    </CommandItem>
                                ))}
                            </CommandGroup>
                        </CommandList>
                    </Command>
                </PopoverContent>
            </Popover>
        </div>
    );
} 
